import type { TourSpec } from "./types";

export const statsTour: TourSpec = {
  id: "stats",
  version: 1,
  buildSteps: (t) => [
    {
      target: '[data-tour="realm-stats-table"]',
      title: t("stats.table.title"),
      content: t("stats.table.body"),
      placement: "center",
      skipBeacon: true,
    },
  ],
};
